// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceDropDown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Detail component
 */

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import classnames from 'classnames';
import DropDown from 'share/components/controls/Izenda.DropDown';
import { BUNDLE, FIELD_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { action } from 'mobx';
import { isNil, isUndefined, uniqueId } from 'lodash/fp';

@connect({ toClass: true })
export default class QuerySourceDropDown extends Component {
  componentDidUpdate() {
    this.needToValidate && this.props.validation.validate();
  }

  /**
   * Get format text
   * @param {Object} filter
   */
  groupFormatText(field: any) {
    const { reportPartTitle, connectionName, querySourceCategoryName, sourceDataObjectName } = field;
    const titleText = reportPartTitle
      ? reportPartTitle
      : `${connectionName}.${querySourceCategoryName}.${sourceDataObjectName}`;

    return titleText;
  }

  /**
   * Handle change
   * @param {Object} newVal
   * @param {Object} fieldDetails
   */
  handleChange = (newVal: any, fieldDetails: any) => {
    const { reportFilters, value, filter } = this.props;
    if (fieldDetails && !fieldDetails.operatorId && reportFilters) {
      reportFilters.loadDefaultOperator(fieldDetails);
    }

    const setNewFilterDetails = action(() => {
      filter.setFilterDetails(fieldDetails || {}, true);
      reportFilters.disableCascading();
      return true;
    });

    return (!isNil(value)
      ? this.props.confirmFn('Confirmation', {
          description: BUNDLE.MESSAGE.M10
        })
      : Promise.resolve()
    ).then(setNewFilterDetails);
  };

  /**
   * Get option properties
   * @param {Object} field
   */
  getOptionProperties({ isParameter }) {
    return {
      disabled: isParameter,
      style: { display: isParameter ? 'none' : 'block' }
    };
  }

  /**
   * Get label name
   * @param {Object} field
   */
  getLabelName({ sourceFieldName }) {
    return sourceFieldName;
  }

  /**
   * Get value
   * @param {Object} field
   */
  getValue(field: any) {
    const { querySourceType, reportPartTitle, reportFieldAlias, sourceDataObjectName } = field;
    const querySourceFieldId = querySourceType === FIELD_TYPE.AggregatedField ? '' : field.querySourceFieldId;
    return reportPartTitle
      ? querySourceFieldId + reportPartTitle + reportFieldAlias
      : querySourceFieldId + sourceDataObjectName;
  }

  /**
   * Get group by value
   * @param {Object} filter
   */
  getGroupByValue(field: any) {
    const { querySourceType, reportPartTitle, connectionName, querySourceCategoryName, sourceDataObjectName } = field;
    return reportPartTitle
      ? querySourceType
      : `${connectionName}.${querySourceCategoryName}.${sourceDataObjectName}`;
  }

  /**
   * Resolve group label.
   * @param {Object} field
   */
  buildGroupLabel(field: any) {
    return field && field.sourceDataObjectName;
  }

  render() {
    const {
      filter: { querySourceFieldId, isParameter, sourceFieldVisible, sourceFieldFilterable },
      className,
      value
    } = this.props;
    const filterOptionsClassNames = classnames(className, {
      'disabled-elm': isParameter
    });

    if (isUndefined(this.isEmptyValue)) {
      this.isEmptyValue = isNil(value);
    } else {
      this.needToValidate = this.isEmptyValue && !isNil(value);
      this.isEmptyValue = isNil(value);
    }

    return (
      <div>
        <DropDown
          {...this.props}
          className={filterOptionsClassNames}
          valueField={this.getValue}
          labelField={this.getLabelName}
          groupBy={this.getGroupByValue}
          maskedHidden={!(sourceFieldVisible && sourceFieldFilterable)}
          onChange={this.handleChange}
          groupFormatText={this.groupFormatText}
          buildGroupLabel={this.buildGroupLabel}
          getOptionProperties={this.getOptionProperties}
          disabledBlankOption
          defaultValue=''
          key={uniqueId(querySourceFieldId)}
          showTooltip
          optionTooltip='reportPartTitle'
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.QuerySourceDropDown.js